import { isNil } from 'lodash';
import { isAllowedToTransformEvents, isAllowedToDeliverEvents } from '@ion/api';

export default function buildDisabledTabs({
  hasValidInputEvent,
  validatingEvent,
  pipelineIntegration,
  pipelineOutput,
  integrationOutput,
}) {
  const canTransformEvent = isAllowedToTransformEvents();
  const canDeliverEvent = isAllowedToDeliverEvents();
  const pipelineOutputDisabled = validatingEvent || !(hasValidInputEvent && canTransformEvent);
  let pipelineOutputDisabledTooltip;
  let integrationOutputDisabled = false;
  let integrationOutputDisabledTooltip;
  const serverResponseDisabled = isNil(integrationOutput?.outputEvent) || !canDeliverEvent;
  let serverResponseDisabledTooltip;

  if (validatingEvent) {
    pipelineOutputDisabledTooltip = 'Validating event...';
  } else if (!hasValidInputEvent && !canTransformEvent) {
    pipelineOutputDisabledTooltip = 'A valid Test Event and permission to transform events are required';
  } else if (!hasValidInputEvent) {
    pipelineOutputDisabledTooltip = 'A valid Test Event is required';
  } else if (!canTransformEvent) {
    pipelineOutputDisabledTooltip = 'You do not have permission to transform events';
  }

  if (isNil(pipelineOutput?.outputEvent) && !canTransformEvent) {
    integrationOutputDisabled = true;
    integrationOutputDisabledTooltip = 'Pipeline Output and permission to transform events are required';
  } else if (isNil(pipelineOutput?.outputEvent)) {
    integrationOutputDisabled = true;
    integrationOutputDisabledTooltip = 'Pipeline Output and selected Integration is required';
  } else if (isNil(pipelineIntegration) && !canTransformEvent) {
    integrationOutputDisabled = true;
    integrationOutputDisabledTooltip = 'Integration and permission to transform events are required';
  } else if (isNil(pipelineIntegration)) {
    integrationOutputDisabled = true;
    integrationOutputDisabledTooltip = 'Integration is required';
  } else if (!canTransformEvent) {
    integrationOutputDisabled = true;
    integrationOutputDisabledTooltip = 'You do not have permission to transform events';
  }

  if (isNil(integrationOutput?.outputEvent) && !canDeliverEvent) {
    serverResponseDisabledTooltip = 'Integration Output and permission to deliver events are required';
  } else if (isNil(integrationOutput?.outputEvent)) {
    serverResponseDisabledTooltip = 'Integration Output is required';
  } else if (!canDeliverEvent) {
    serverResponseDisabledTooltip = 'You do not have permission to deliver events';
  }

  return {
    pipelineOutputDisabled,
    pipelineOutputDisabledTooltip,
    integrationOutputDisabled,
    integrationOutputDisabledTooltip,
    serverResponseDisabled,
    serverResponseDisabledTooltip,
  };
}
